export default __webpack_public_path__ + "static/media/language-icon.32532bde.svg";